import { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { API } from '../api'

export function LoginPage() {
    const [turma, setTurma] = useState('')
    const [email, setEmail] = useState('')
    const [turmaValid, setTurmaValid] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const navigate = useNavigate()

    const handleValidateTurma = async () => {
        setLoading(true)
        setError('')
        try {
            const res = await axios.post(`${API.AUTH}/validate-turma`, { turmaId: turma })
            if (res.data) {
                setTurmaValid(true)
            }
        } catch (err: any) {
            setError(err.response?.data?.error || 'Erro ao validar turma')
        } finally {
            setLoading(false)
        }
    }

    const handleLogin = async () => {
        setLoading(true)
        setError('')
        try {
            const res = await axios.post(`${API.AUTH}/verify-access`, {
                turmaId: turma,
                email
            })

            const { token, permissao, nome: userName, aceiteTermos } = res.data
            sessionStorage.setItem('token', token)
            sessionStorage.setItem('turma', turma)
            sessionStorage.setItem('email', email)
            if (userName) sessionStorage.setItem('nome', userName)

            if (permissao === 0) {
                // Termos já aceitos (gravado no cadastro): não precisa aceitar de novo
                navigate(aceiteTermos ? '/menu' : '/terms')
            } else {
                navigate('/menu')
            }
        } catch (err: any) {
            setError(err.response?.data?.error || 'Acesso negado ou erro de validação.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div style={{ 
            backgroundColor: 'white', 
            color: '#333', 
            minHeight: '100dvh', 
            width: '100%', 
            maxWidth: '100%',
            overflowX: 'hidden',
            margin: 0, 
            padding: 'clamp(16px, 4vw, 24px)',
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{ 
                maxWidth: '400px',
                width: '100%',
                padding: 0
            }}>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <div style={{ 
                        width: '64px', 
                        height: '64px', 
                        backgroundColor: '#0e1d72', 
                        borderRadius: '12px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        margin: '0 auto 16px'
                    }}>
                        <span style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>BMI</span>
                    </div>
                    <h1 style={{ fontSize: 'clamp(24px, 6vw, 28px)', fontWeight: 'bold', color: '#0e1d72', margin: '0 0 8px' }}>
                        BMI App Cap Jota
                    </h1>
                </div>

                <div style={{ 
                    backgroundColor: '#f8f9fa', 
                    padding: 'clamp(20px, 5vw, 30px)', 
                    borderRadius: '12px', 
                    border: '1px solid #ddd',
                    width: '100%',
                    boxSizing: 'border-box'
                }}>
                    <div style={{ marginBottom: '20px' }}>
                        <label htmlFor="input-turma" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                            Código da Turma
                        </label>
                        <input
                            id="input-turma"
                            type="number"
                            value={turma}
                            onChange={(e) => setTurma(e.target.value)}
                            disabled={turmaValid}
                            placeholder="Digite o código"
                            style={{ 
                                width: '100%', 
                                padding: '12px 14px', 
                                border: '1px solid #ddd', 
                                borderRadius: '8px',
                                fontSize: '16px',
                                minHeight: '48px',
                                boxSizing: 'border-box',
                                backgroundColor: turmaValid ? '#e9ecef' : 'white'
                            }}
                        />
                        {!turmaValid && (
                            <button
                                onClick={handleValidateTurma}
                                disabled={loading || !turma}
                                style={{ 
                                    width: '100%',
                                    marginTop: '12px',
                                    padding: '12px', 
                                    backgroundColor: loading ? '#6c757d' : '#0e1d72', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '8px', 
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    fontSize: '15px',
                                    fontWeight: 'bold',
                                    minHeight: '48px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxSizing: 'border-box'
                                }}
                            >
                                {loading ? 'Validando...' : 'Validar Turma'}
                            </button>
                        )}
                    </div>

                    {turmaValid && (
                        <div style={{ 
                            animation: 'slideDown 0.3s ease-out',
                            marginBottom: '20px'
                        }}>
                            <label htmlFor="input-email" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                                Login
                            </label>
                            <input
                                id="input-email"
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ 
                                    width: '100%', 
                                    padding: '12px 14px', 
                                    border: '1px solid #ddd', 
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    minHeight: '48px',
                                    boxSizing: 'border-box'
                                }}
                            />
                            <button
                                onClick={handleLogin}
                                disabled={loading || !email}
                                style={{ 
                                    width: '100%',
                                    marginTop: '12px',
                                    padding: '12px', 
                                    backgroundColor: loading ? '#6c757d' : '#0e1d72', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '8px', 
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    fontSize: '15px',
                                    fontWeight: 'bold',
                                    minHeight: '48px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxSizing: 'border-box'
                                }}
                            >
                                {loading ? 'Acessando...' : 'Acessar'}
                            </button>
                        </div>
                    )}

                    {error && (
                        <div role="alert" style={{ 
                            marginTop: '15px',
                            padding: '12px', 
                            backgroundColor: '#fee', 
                            border: '1px solid #fcc', 
                            borderRadius: '8px', 
                            color: '#c53030',
                            fontSize: '14px',
                            lineHeight: '1.4'
                        }}>
                            {error}
                        </div>
                    )}
                </div>

                <div style={{
                    marginTop: '20px',
                    padding: '8px 12px',
                    fontSize: '12px',
                    color: '#888',
                    textAlign: 'center',
                    lineHeight: '1.5'
                }}>
                    Seus dados são tratados conforme a LGPD. Ao acessar, você confirma que leu e aceita os termos de uso.
                </div>
            </div>

            <style>{`
                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </div>
    )
}
